import React, { useEffect } from "react";
import I18n from "i18n";
import Analytics from "libraries/analytics";
import AgentResultDownload from "models/agentResultDownload";
import Shortcutter from "libraries/shortcutter";

interface Props {
  agentResult: any; // Backbone.Model (SelectedAgentResults)
}

export default function DatalakeHeaderDownload({ agentResult }: Props) {
  function handleDownloadClick() {
    const agentResultDownload = new AgentResultDownload({ agentResult });
    agentResultDownload.downloadPDF();
    Analytics.sendEvent("br_agent_result_downloaded", {
      kind: agentResult.get("kind"),
    });
  }

  useEffect(() => {
    if (agentResult.downloadable()) {
      const shortcutModule = "agents";
      const shortcutKey = "d";
      const shortcutHandler = handleDownloadClick;

      Shortcutter.bindInModule(shortcutModule, shortcutKey, shortcutHandler);
      return () => {
        Shortcutter.unbindInModule(shortcutModule, [shortcutKey]);
      };
    }
  }, [handleDownloadClick, agentResult]);

  return (
    <>
        <a
          id="clip-download"
          className="link-bar__left-item"
          onClick={handleDownloadClick}
          style={{ cursor: "pointer" }}
        >
          <i className="icon-download"></i>{" "}
          {I18n.t("webapp.agents.results.result_details.download")}
        </a>
    </>
  );
}
